import { useEffect } from "react";
import "@/App.css";

// The actual site is a hand-coded HTML/CSS/JS portfolio served from
// /public/portfolio/. React simply redirects to it so the same preview URL
// shows the portfolio.
function App() {
  useEffect(() => {
    window.location.replace("/portfolio/index.html");
  }, []);

  return (
    <div
      data-testid="portfolio-redirect"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#070b18",
        color: "#e2e8f0",
        fontFamily: "Inter, system-ui, sans-serif",
      }}
    >
      <p>
        Loading portfolio…&nbsp;
        <a
          href="/portfolio/index.html"
          style={{ color: "#38bdf8" }}
          data-testid="portfolio-link"
        >
          Click here if it doesn&rsquo;t open.
        </a>
      </p>
    </div>
  );
}

export default App;
